import {css, html, LitElement, unsafeCSS} from "lit";
import {pxToRem} from "../../webcomponents/styles";
import {lamudiAssetsPath} from "../common/variables";

class LamudiSnippet extends LitElement {
    private name: string;
    private location: string;
    private description: string;
    private price: string;
    private bedrooms: string;
    private bathrooms: string;
    private area: string;
    private carPark: string;
    private image: string;
    private numberOfImages: string;
    private url: string;
    private moreInfo: string;

    constructor() {
        super();
        this.name = "";
        this.location = "";
        this.description = "";
        this.price = "";
        this.bedrooms = "";
        this.bathrooms = "";
        this.area = "";
        this.carPark = "";
        this.image = "";
        this.numberOfImages = "";
        this.url = "";
        this.moreInfo = "";
    }

    public static properties = {
        name: {type: String},
        location: {type: String},
        description: {type: String},
        price: {type: String},
        bedrooms: {type: String},
        bathrooms: {type: String},
        area: {type: String},
        carPark: {type: String, attribute: "car-park"},
        image: {type: String},
        numberOfImages: {type: String, attribute: "number-of-images"},
        url: {type: String},
        moreInfo: {type: String, attribute: "more-info"},
    }
    /*
        Copied from webpack generated lamudi entry lamudiMapSnippet.css
        Removed some media queries
     */
    private static stylesRaw: string = `
        .snippet {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            gap: 0;
            overflow: visible;
            flex-direction: row;
        }

        .snippet a {
            text-decoration: none;
            width: 100%
        }

        .snippet.hidden {
            display: none;
        }

        .snippet .highLight, .snippet .recentPublished {
            position: absolute;
            display: flex;
            align-items: center;
            padding: 0.3125rem 0.625rem;
            background: #FFFFFF;
            border-radius: 0.25rem;
            font-weight: 500;
            font-size: 0.8125rem;
            line-height: 0.875rem;
            color: #000000;
            z-index: 2;
            margin: 0.625rem;
            text-align: center;
            left: 0.3125rem;
            top: 0.3125rem;
        }

        .snippet .highLight {
            width: auto;
            background: rgba(0, 0, 0, 0.33);
            color: #FFFFFF;
            left: auto;
            right: 0.3125rem;
        }

        .snippet__image {
            position: relative;
            display: flex;
            object-fit: cover;
            overflow: hidden;
            flex-shrink: 0;
            width: 100%;
            margin: 0;
            border-radius: 0.625rem 0.625rem 0 0;
            flex-direction: column;
            height: 100%;
        }

        .snippet__image .swiper-container {
            margin: 0;
        }

        .snippet__image .swiper-container img {
            height: ${pxToRem(225)};
        }

        .snippet__image img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: 0;
        }

        .snippet__image .tagProject {
            display: none;
        }

        .snippet__image .info {
            display: flex;
            justify-content: center;
            margin-left: 0;
            width: auto;
            font-size: 0.75rem;
            font-weight: 600;
            color: #FFFFFF;
            position: absolute;
            align-items: center;
            z-index: 1;
            gap: 0.25rem;
            bottom: 0.625rem;
            left: 0.625rem;
        }

        .snippet__image .info__icon {
            display: flex;
            gap: 0.25rem;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 0.25rem;
            height: 2rem;
            padding: 0.25rem;
            align-items: center;
        }

        .snippet__image .info__icon::before {
            content: "";
            filter: invert(93%) sepia(94%) saturate(0%) hue-rotate(248deg) brightness(106%) contrast(106%);
            background-size: cover;
            background-repeat: no-repeat;
            width: 1.5rem;
            height: 1.5rem;
        }

        .snippet__image .info__icon.pictures {
            padding: 0.375rem;
            gap: 0.25rem;
        }

        .snippet__image .info__icon.pictures::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/photo.svg");
            filter: invert(93%) sepia(94%) saturate(0%) hue-rotate(248deg) brightness(106%) contrast(106%);
            background-size: cover;
            width: 1.5rem;
            height: 1.5rem;
            margin: 0;
        }

        .snippet__image .info__icon.video::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/video.svg");
        }

        .snippet__image .info__icon.floor-plans::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/plan.svg");
        }

        .snippet__image .info__icon.virtual-tour::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/360.svg");
        }

        .snippet .serp-buttons {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0.0625rem solid;
            font-size: 0.875rem;
            font-weight: 700;
            line-height: 1.1875rem;
            border-radius: 0.25rem;
            height: 2.1875rem;
        }

        .snippet .more-info {
            background-color: #ffffff;
            color: #3366CC;
            border-color: #3366CC;
        }

        .snippet .whatsapp {
            color: #FFFFFF;
            border-color: #25D366;
            background-color: #25D366;
        }

        .snippet .whatsapp::before {
            display: block;
            content: "";
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url("${lamudiAssetsPath}/common/images/whatsapp-icon.svg");
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.25rem;
            filter: invert(95%) sepia(0%) saturate(7476%) hue-rotate(111deg) brightness(106%) contrast(100%);
        }

        .snippet .snippet-contact {
            color: #FFFFFF;
            border-color: #FF8700;
            background-color: #FF8700;
        }

        .snippet .snippet-contact::before {
            display: block;
            content: "";
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/mail-icon.svg");
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.25rem;
            filter: invert(95%) sepia(0%) saturate(7476%) hue-rotate(111deg) brightness(106%) contrast(100%);
        }

        .snippet:has(.snippet__favorite) {
            position: relative;
        }

        .snippet:has(.snippet__favorite) .snippet__favorite {
            position: absolute;
            bottom: 1rem;
            right: 0.875rem;
        }

        .snippet:has(.snippet__favorite) .snippet__content .serp-buttons {
            width: 84%;
        }

        .snippet:has(.snippet__favorite) .snippet__buttons-container__elements {
            justify-content: normal;
        }

        .snippet:has(.snippet__favorite) .snippet__buttons-container__elements .serp-buttons {
            width: 8rem;
        }

        .snippet__content {
            display: flex;
            flex-direction: column;
            gap: 0.375rem;
            min-height: 5.625rem;
            background-color: #FFFFFF;
            width: 100%;
            padding: 0.875rem 0.875rem 0.375rem 0.875rem;
            margin: 0;
            border-radius: 0 0 0.625rem 0.625rem;
        }

        .snippet__content a {
            display: flex;
            flex-direction: column;
            gap: 0.375rem;
        }

        .snippet__content__agency {
            display: flex;
            align-items: center;
            gap: 0.3125rem;
        }

        .snippet__content__agency__name {
            font-size: 0.75rem;
            color: #4a4a4a;
        }

        .snippet__content__agency__premium {
            width: 1.5rem;
            height: 1.5rem;
            background-color: #FF8700;
            border-radius: 50%;
            padding: 0.125rem;
            cursor: pointer;
        }

        .snippet__content__agency__premium .premium-icon {
            border: none;
            filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(3deg) brightness(105%) contrast(102%);
            width: 1.25rem;
            height: 1.25rem;
            vertical-align: unset;
        }

        .snippet__content__agency__special-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            border: 0.0625rem solid #999999;
            flex-shrink: 0;
            color: #999999;
        }

        .snippet__content__agency__premium {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .snippet__content__title {
            font-weight: 700;
            color: #3366CC;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 1.1875rem;
            font-size: ${pxToRem(16)};
        }

        .snippet__content__distance {
            background-color: rgba(255, 135, 0, 0.2);
            padding: 0.1875rem;
            font-size: 0.75rem;
            font-weight: 700;
            color: #0A0A0A;
            max-width: calc(100vw - 178px);
            white-space: nowrap;
            width: fit-content;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .snippet__content__location {
            display: flex;
            align-items: flex-start;
            gap: 0.25rem;
            font-size: 0.75rem;
            font-weight: 700;
            color: #0A0A0A;
            line-height: 1rem;
        }

        .snippet__content__location span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }

        .snippet__content__location::before {
            content: "";
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-map-pointer.svg");
            background-repeat: no-repeat;
            width: 0.75rem;
            height: 0.75rem;
            background-size: 0.75rem 0.75rem;
            flex-shrink: 0;
            margin-top: 0.0625rem;
        }

        .snippet__content__description {
            display: none;
        }

        .snippet__content__price {
            display: flex;
            flex-wrap: wrap;
            gap: 0.375rem;
            font-size: 1.125rem;
            color: #0A0A0A;
            font-weight: 700;
            line-height: 1.5625rem;
        }

        .snippet__content__price .foreclosure {
            font-size: 0.875rem;
            color: #3366CC;
            display: flex;
            gap: 0.25rem;
            align-items: center;
            font-weight: 400;
        }

        .snippet__content__price .foreclosure::before {
            content: "";
            width: 1.5rem;
            height: 1.5rem;
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/foreclosuresTag.webp");
            background-repeat: no-repeat;
            background-size: contain;
        }

        .snippet__content__properties {
            display: flex;
            align-items: center;
            font-weight: 400;
            justify-content: flex-start;
            gap: 0.625rem;
        }

        .snippet__content__properties .property {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            flex-shrink: 0;
            gap: 0.25rem;
        }

        .snippet__content__properties .property__number {
            display: flex;
            font-size: 0.75rem;
            align-self: flex-start;
            align-items: center;
            color: #0A0A0A;
        }

        .snippet__content__properties .property__number::before {
            content: "";
            background-repeat: no-repeat;
            width: 1rem;
            height: 1rem;
            background-size: 1rem 1rem;
            margin-right: 0.3125rem;
        }

        .snippet__content__properties .property__text {
            font-weight: 400;
            font-size: 0.625rem;
            line-height: 0.875rem;
            color: #4a4a4a;
        }

        .snippet__content__properties .property .bedrooms::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-beds.svg");
        }

        .snippet__content__properties .property .bathrooms::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-bath.svg");
        }

        .snippet__content__properties .property .area {
            flex-shrink: 1;
        }

        .snippet__content__properties .property .area::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-area.svg");
        }

        .snippet__content__properties .property .principal-amenity {
            flex-shrink: 1;
        }

        .snippet__content__properties .property .principal-amenity::before {
            filter: invert(6%) sepia(7%) saturate(0%) hue-rotate(180deg) brightness(0%) contrast(100%);
        }

        .snippet__content__properties .property .terrace::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/terrace.svg");
        }

        .snippet__content__properties .property .garden::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/garden.svg");
        }

        .snippet__content__properties .property .balcony::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/balcony.svg");
        }

        .snippet__content__properties .property .car_park::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/car_park_V3.svg");
        }

        .snippet__content__properties .property .swimming_pool::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/swimming_pool.svg");
        }

        .snippet__content__properties .property .gym::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/gym.svg");
        }

        .snippet__content__properties .property .yard::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/yard.svg");
        }

        .snippet__content__properties .property .furnished::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/furnished.svg");
        }

        .snippet__content__properties .property .service_room::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/service_room.svg");
        }

        .snippet__content__properties .property .security::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/security.svg");
        }

        .snippet__content__properties .property .guardhouse::before {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/guardhouse.svg");
        }

        .snippet__content__opportunity {
            background-color: rgba(51, 102, 204, 0.1);
            border-radius: 1.25rem;
            width: fit-content;
        }

        .snippet__content__opportunity__text {
            padding: 0.125rem 0.5rem;
            color: #3366CC;
            display: flex;
            align-items: center;
            font-size: 0.75rem;
        }

        @media only screen and (min-width: 320px) and (max-width: 375px) {
            .snippet__content__opportunity__text {
                font-size: 0.625rem;
            }
        }

        .snippet__content__opportunity__text::before {
            display: block;
            content: "";
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/downtrend.svg");
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.5rem;
            filter: brightness(0) saturate(100%) invert(37%) sepia(36%) saturate(2562%) hue-rotate(197deg) brightness(87%) contrast(82%);
        }

        .snippet__content__opportunity__text strong {
            margin: 0 0.25rem;
        }

        .snippet__content__buttons-and-agency {
            display: none;
            padding: 0.25rem 0;
        }

        .snippet__content__buttons-and-agency .more-info {
            width: 100%;
        }

        .snippet__content__buttons-and-agency .whatsapp {
            display: none;
        }

        .snippet__content__buttons-and-agency .agency {
            display: none;
            position: relative;
            overflow: visible;
        }

        .snippet__content__buttons-and-agency .agency__premium {
            width: 1.5rem;
            height: 1.5rem;
            background-color: #FF8700;
            border-radius: 50%;
            padding: 0.125rem;
            cursor: pointer;
        }

        .snippet__content__buttons-and-agency .agency__premium .premium-icon {
            border: none;
            filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(3deg) brightness(105%) contrast(102%);
            width: 1.25rem;
            height: 1.25rem;
            vertical-align: unset;
        }

        .snippet__content__buttons-and-agency .agency__special-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            border: 0.0625rem solid #999999;
            flex-shrink: 0;
            color: #999999;
        }

        .snippet__content__buttons-and-agency .agency__premium {
            display: flex;
            position: absolute;
            top: -0.5rem;
            left: 1.5625rem;
        }

        .snippet__content__buttons-and-agency:not(:has(.whatsapp)) {
            display: flex;
        }

        .snippet__content > *:last-child {
            margin-top: auto;
        }

        .snippet__buttons-container {
            width: 100%;
        }

        .snippet__buttons-container__elements {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            gap: 0.5rem;
            padding: 0.25rem 0.875rem 0.875rem 0.875rem;
            /*
            FIXME este elemento debería estar dentro del content y jugar con el gap y un único padding
            o, posiblemente, no debería haber un "buttons" y un "buttons-and-agency" y debería ser este último para todos los dispositivos
            */
        }

        .snippet__buttons-container__elements .serp-buttons {
            width: 50%;
        }

        .snippet__buttons-container:not(:has(.whatsapp)) {
            display: none;
        }

        .snippet.project.is-project-serp {
            height: auto;
        }

        .snippet.project.is-project-serp .snippet__content {
            background-color: #FFFFFF;
            gap: 0.375rem;
            padding: 0.875rem;
            margin: 0;
        }

        .snippet.project.is-project-serp .snippet__content__location {
            align-items: center;
        }

        .snippet.project.is-project-serp .snippet__content__properties {
            justify-content: flex-start;
            gap: 0.625rem;
        }

        .snippet.project.is-project-serp .snippet__content__properties .property {
            width: auto;
            gap: 0.25rem;
        }

        .snippet.project {
            flex-direction: column;
        }

        .snippet.project .snippet__image .tagProject {
            font-size: 0.875rem;
            line-height: 1.1875rem;
            color: #FFFFFF;
            position: absolute;
            bottom: 0;
            right: 0;
            padding: 0.9375rem;
            width: inherit;
            height: 2rem;
            background: #3366CC;
            display: flex;
            align-items: center;
        }

        .snippet.project .snippet__image .info {
            bottom: 2.1875rem;
        }

        .snippet.project .snippet__content {
            background: rgba(51, 102, 204, 0.05);
        }

        .snippet.project .snippet__content__units-container {
            display: flex;
        }

        .snippet.project .snippet__content__units-container .units {
            display: flex;
            flex-direction: row;
            gap: 0.5rem;
            flex-wrap: nowrap;
            width: 100%;
            overflow-x: auto;
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
            padding: 0 0.375rem;
        }

        .snippet.project .snippet__content__units-container .units::-webkit-scrollbar {
            width: 0;
        }

        .snippet.project .snippet__content__units-container .units__button-left, .snippet.project .snippet__content__units-container .units__button-right {
            width: 1.5rem;
            height: 6.25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(51, 102, 204, 0.2);
            cursor: pointer;
        }

        .snippet.project .snippet__content__units-container .units__button-left {
            border-radius: 0.25rem 0 0 0.25rem;
        }

        .snippet.project .snippet__content__units-container .units__button-left .left-arrow {
            content: url("${lamudiAssetsPath}/lamudi/common/images/icon-arrowright_m_primary.svg");
            transform: rotate(180deg);
            height: 1.5rem;
            width: 1.5rem;
        }

        .snippet.project .snippet__content__units-container .units__button-right {
            border-radius: 0 0.25rem 0.25rem 0;
        }

        .snippet.project .snippet__content__units-container .units__button-right .right-arrow {
            content: url("${lamudiAssetsPath}/lamudi/common/images/icon-arrowright_m_primary.svg");
            height: 1.5rem;
            width: 1.5rem;
        }

        .snippet.project .snippet__content__units-container .units .unit {
            background-color: rgba(51, 102, 204, 0.05);
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
            padding: 1rem;
            gap: 0.1875rem;
            width: 13.8125rem;
            height: 6.3125rem;
            font-style: normal;
            font-weight: 700;
        }

        .snippet.project .snippet__content__units-container .units .unit__title {
            display: inline-block;
            width: 100%;
            font-size: 0.875rem;
            line-height: 1.1875rem;
            color: #3366CC;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .snippet.project .snippet__content__units-container .units .unit__price {
            display: inline-block;
            width: 100%;
            font-size: 1rem;
            line-height: 1.375rem;
            color: #0A0A0A;
        }

        .snippet.project .snippet__content__units-container .units .unit__properties {
            display: flex;
            font-size: 1rem;
            line-height: 1.375rem;
            color: #0A0A0A;
            gap: 0.75rem;
        }

        .snippet.project .snippet__content__units-container .units .unit__properties .unit__property {
            display: flex;
        }

        .snippet.project .snippet__content__units-container .units .unit__properties .unit__property .property__number {
            display: flex;
            align-items: center;
        }

        .snippet.project .snippet__content__units-container .units .unit__properties .unit__property .property__number .bedrooms {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-beds.svg");
            background-repeat: no-repeat;
            width: 1rem;
            height: 1rem;
            background-size: 1rem 1rem;
            margin-right: 0.3125rem;
        }

        .snippet.project .snippet__content__units-container .units .unit__properties .unit__property .property__number .bathrooms {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-bath.svg");
            background-repeat: no-repeat;
            width: 1rem;
            height: 1rem;
            background-size: 1rem 1rem;
            margin-right: 0.3125rem;
        }

        .snippet.project .snippet__content__units-container .units .unit__properties .unit__property .property__number .area {
            background-image: url("${lamudiAssetsPath}/lamudi/common/images/icon-area.svg");
            background-repeat: no-repeat;
            width: 1rem;
            height: 1rem;
            background-size: 1rem 1rem;
            margin-right: 0.3125rem;
        }

        .snippet.project .snippet__content__buttons-and-agency .more-info {
            background-color: initial;
        }

        .snippet__next-images {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            width: 100%;
            align-content: center;
            justify-content: center;
            gap: 0.125rem;
            margin-top: 0.125rem;
        }

        .snippet__next-images img {
            height: 5.0625rem;
            object-fit: cover;
        }

        .snippet__next-images .last-image {
            position: relative;
        }

        .snippet__next-images .last-image__text-overlay {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            color: #FFFFFF;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 0.75rem;
            font-weight: 700;
            line-height: 1.02125rem;
        }
    `
    public static styles =  css`${unsafeCSS(LamudiSnippet.stylesRaw)}`;

    // This is a coppy of lamudi/snippet.ftl. Maybe is genarable from backend :thinking:
    protected render() {
        return html`
            <div class="snippet js-snippet normal">
                <a href="${this.url}" target="_blank">
                    <div class="snippet__image">
                        <div class="swiper-container gallery-swiper-container">
                            <img src="${this.image}" alt="${this.name}">
                            <div class="info">
                                <div class="swiper-pagination-one info__icon pictures">
                                    <span class="swiper-pagination-total">${this.numberOfImages}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
                <div class="snippet__content">
                    <a href="${this.url}" target="_blank">
                        <span class="snippet__content__title">${this.name}</span>
                        <div class="snippet__content__location">
                            <span data-test="snippet-content-location">${this.location}</span>
                        </div>
                        <div class="snippet__content__description">
                            ${this.description}
                        </div>
                        <div class="snippet__content__price">
                            ${this.price}
                        </div>
                        <div class="snippet__content__properties">
                            ${this.renderProperty("bedrooms", this.bedrooms)}
                            ${this.renderProperty("bathrooms", this.bathrooms)}
                            ${this.renderProperty("area", this.area)}
                            ${this.renderProperty("car_park", this.carPark)}
                        </div>
                    </a>
                    <a href="${this.url}">
                        <div class="snippet__content__buttons-and-agency">
                            <button class="more-info serp-buttons">${this.moreInfo}</button>
                        </div>
                    </a>
                </div>
            </div>
        `
    }

    private renderProperty(name: string, value: string) {
        if ("0" == value || value == "") {
            return ""
        }

        return html`<div class="property">
            <span class="property__number ${name}">${value}</span>
        </div>`
    }
}

customElements.define('lamudi-snippet', LamudiSnippet);